import React from 'react';

/*
  TimeSlotButton component
  Props:
    - slot: slot object { id, label, duration, type }
    - selected: boolean
    - onSelect: function
*/
function TimeSlotButton({ slot, selected, onSelect }) {
  return (
    <button
      className={`slot-btn ${selected ? 'selected' : ''} ${slot.type}`}
      onClick={onSelect}
      type="button"
    >
      <span className="slot-time">{slot.label}</span>
      <span className="slot-duration">{slot.duration} min available</span>
      <span className="slot-status">✅ Available</span>
    </button>
  );
}

export default React.memo(TimeSlotButton);